import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

import { PageHeader } from 'components/Page';

function IntegrationsHeader({ goToPath, title, level }) {
  const navigate = useNavigate();
  return (
    <PageHeader
      goBack={() => navigate(goToPath)}
      title={
        <div className="d-flex justify-content-between align-items-center w-100">
          <h2>{title}</h2>
          <span className="text-uppercase">{level} level</span>
        </div>
      }
    />
  );
}

IntegrationsHeader.propTypes = {
  goToPath: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  level: PropTypes.string.isRequired,
};

export default IntegrationsHeader;
